import { useNavigate, useSearchParams, useParams } from 'react-router-dom'

import { Box, FloraTypography } from '@grupoboticario/flora-react'

import EventForm from '@/components/EventForm'
import { LOADING_MESSAGES } from '@/constants/eventMessages'
import { loadingBoxStyle } from '@/features/event/styles'
import useEventData from '@/features/event/useEventData'
import useEventSubmit from '@/features/event/useEventSubmit'

const BenefitEventPage = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { eventId: paramEventId } = useParams()
  const eventId = searchParams.get('event') ?? paramEventId
  const isNewEvent = eventId === 'new'
  const isReadOnly = searchParams.get('readonly') === 'true'

  const query = { event: eventId, readonly: searchParams.get('readonly') }

  const { formValues, setFieldValue, isLoadingEvent, refreshEvent } = useEventData({
    eventId,
    isNewEvent,
    query,
    push: navigate
  })

  const { handleSubmit, isUploading, isSaving } = useEventSubmit({
    formValues,
    eventId,
    isNewEvent,
    push: navigate,
    refreshEvent
  })

  if (isLoadingEvent && !isNewEvent) {
    return (
      <Box css={loadingBoxStyle}>
        <FloraTypography fontSize="bodyLargeStandard">{LOADING_MESSAGES.LOADING_EVENT}</FloraTypography>
      </Box>
    )
  }

  return (
    <EventForm
      formValues={formValues}
      handleSubmit={handleSubmit}
      isLoading={isUploading || isSaving}
      isNewEvent={isNewEvent}
      isReadOnly={isReadOnly}
      onCancel={() => navigate(-1)}
      onSubmit={handleSubmit}
      setFieldValue={setFieldValue}
    />
  )
}

export { BenefitEventPage }
